import { Injectable } from '@angular/core';

import { contasContabeisStorage } from "./data.service";
import { AutoCompleteService } from "../../../shared/components/autocomplete/autocomplete.service";
import { gruposMateriaisStorage } from "../../../almoxarifado/grupos-materiais/shared/data.service";
import { GrupoMaterialService } from "../../../almoxarifado/grupos-materiais/shared/grupo-material.service";
import { GrupoMaterialNavigationService } from "../../../almoxarifado/grupos-materiais/shared/grupo-material-navigation.service";
import { MaterialService } from "../../../almoxarifado/materiais/material/shared/material.service";
import { materialStorageName } from "../../../almoxarifado/materiais/material/shared/data.service";

declare var $: any;

@Injectable()
export class ContaContabilService {

    constructor(
        private _grupoMaterialService: GrupoMaterialService,
        private _grupoMaterialNavigationService: GrupoMaterialNavigationService,
        private _materialService: MaterialService,
        private _autocompleteService: AutoCompleteService
    ){}

    //session
    setSessionStorage(item: any) {
        var object: string = JSON.stringify(item);
        sessionStorage.setItem(contasContabeisStorage + '-new', object);
    }

    getSessionStorage() {
        var item: string = sessionStorage.getItem(contasContabeisStorage + "-new");
        return JSON.parse(item);
    }

    clearSessionStorage() {
        sessionStorage.removeItem(contasContabeisStorage + "-new");
    }

    returnToOtherForm(otherForm: string, Response: any) {
        var otherFormObject: any;
        if(Response) {
            if (otherForm === gruposMateriaisStorage) {
                otherFormObject = this._grupoMaterialService.getSessionStorage();
                otherFormObject.contaContabil = Response;
                this._grupoMaterialService.setSessionStorage(otherFormObject);
            } else if (otherForm === materialStorageName) {
                otherFormObject = this._materialService.getSessionStorage();
                otherFormObject.contaContabil = Response;
                this._materialService.setSessionStorage(otherFormObject);
            }
        }

        this._autocompleteService.clearSessionStorage(contasContabeisStorage);

        if (otherForm === gruposMateriaisStorage) {
            otherFormObject = this._grupoMaterialService.getSessionStorage();
            if (otherFormObject.id) {
                this._grupoMaterialNavigationService.goToEditSubgrupo(otherFormObject.grupoId, otherFormObject.id);
            } else {
                this._grupoMaterialNavigationService.goToAddSubgrupo(otherFormObject.grupoId);
            }
        } else if (otherForm === materialStorageName) {
            otherFormObject = this._materialService.getSessionStorage();
            if (otherFormObject.id) {
                this._materialService.goToEdit(otherFormObject.id);
            } else {
                this._materialService.goToAdd();
            }
        }
    }

    //others
    //parametros: fatherCode=codigo da conta contabil pai / nextCode=codigo a ser adotado pela conta filho
    //retorna o novo codigo da conta filho
    getLastCodeNumber(fatherCode: string, nextCode: string) {
        var codeSplit: string[] = fatherCode.split(".");
        var first0: number = codeSplit.indexOf("0");
        var newCode: string = '';

        if (first0 === -1) {
            first0 = codeSplit.indexOf("00");
            if (nextCode.length === 1) {
                nextCode = "0".concat(nextCode);
            }
        }

        codeSplit[first0] = nextCode;
        newCode = codeSplit.toString();
        newCode = newCode.replace(/,/g, ".");
        return newCode;
    }

    //select2 para a caonta contabil
    templateResult = (function(state: any, isCreateNew: boolean) {
        var stateReturn: any,
            text: string;

        if (state.loading) {
            stateReturn = state.text;
        } else {
            if (state.id === -1) {
                if (isCreateNew) {
                    stateReturn = this._autocompleteService.setNewTagInList(state);
                } else {
                    stateReturn = this._autocompleteService.setNoCreateNew(state.text);
                }
            } else {
                if (state.text) {
                    text = state.text;
                } else {
                    var code: string = '';
                    var description: string = '';

                    if (state.codigo) {
                        code = state.codigo.concat(" - ");
                    }
                    if (state.descricao) {
                        description = state.descricao;
                    }

                    text = code.concat(description);
                }
                stateReturn = $('<span>' + text + '</span>');
            }
        }

        return stateReturn;
    }.bind(this));

    getTipoEstoque() {
        return 1;
    }

    getTipoConsumo() {
        return 2;
    }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/contas/conta-contabil/shared/conta-contabil.service.ts
 **/